var map = {
	"./acnhbanner-min.jpg": 6110,
	"./bells.png": 2891,
	"./fish/Anchovy_ACNH.png": 4126,
	"./fish/Angelfish_ACNH.png": 969,
	"./fish/Arapaima_ACNH.png": 4605,
	"./fish/Arowana_ACNH.png": 9020,
	"./fish/Barred_Knifejaw_ACNH.png": 3392,
	"./fish/Barreleye_ACNH.png": 4964,
	"./fish/Betta_ACNH.png": 5641,
	"./fish/Bitterling_ACNH.png": 510,
	"./fish/Black_Bass_ACNH.png": 3467,
	"./fish/Blowfish_ACNH.png": 5997,
	"./fish/Blue_Marlin_ACNH.png": 6969,
	"./fish/Bluegill_ACNH.png": 3000,
	"./fish/Butterfly_Fish_ACNH.png": 420,
	"./fish/Carp_ACNH.png": 8281,
	"./fish/Catfish_ACNH.png": 7795,
	"./fish/Char_ACNH.png": 4994,
	"./fish/Cherry_Salmon_ACNH.png": 7593,
	"./fish/Clownfish_ACNH.png": 5536,
	"./fish/Coelacanth_ACNH.png": 6358,
	"./fish/Crawfish_ACNH.png": 1361,
	"./fish/Crucian_Carp_ACNH.png": 3766,
	"./fish/Dab_ACNH.png": 3671,
	"./fish/Dace_ACNH.png": 6262,
	"./fish/Dorado_ACNH.png": 5603,
	"./fish/Football_Fish_ACNH.png": 2542,
	"./fish/Freshwater_Goby_ACNH.png": 5936,
	"./fish/Frog_ACNH.png": 5293,
	"./fish/Gar_ACNH.png": 7091,
	"./fish/Giant_Snakehead_ACNH.png": 5895,
	"./fish/Giant_Trevally_ACNH.png": 4780,
	"./fish/Golden_Trout_ACNH.png": 6459,
	"./fish/Goldfish_ACNH.png": 9007,
	"./fish/Great_White_Shark_ACNH.png": 5799,
	"./fish/Guppy_ACNH.png": 3090,
	"./fish/Hammerhead_Shark_ACNH.png": 4826,
	"./fish/Horse_Mackerel_ACNH.png": 6276,
	"./fish/Killifish_ACNH.png": 6343,
	"./fish/King_Salmon_ACNH.png": 9035,
	"./fish/Koi_ACNH.png": 4943,
	"./fish/Loach_ACNH.png": 5629,
	"./fish/Mahi_Mahi_ACNH.png": 511,
	"./fish/Mitten_Crab_ACNH.png": 6465,
	"./fish/Moray_Eel_ACNH.png": 7840,
	"./fish/Napoleonfish_ACNH.png": 4096,
	"./fish/Neon_Tetra_ACNH.png": 5337,
	"./fish/Nibble_Fish_ACNH.png": 7779,
	"./fish/Oarfish_ACNH.png": 9248,
	"./fish/Ocean_Sunfish_ACNH.png": 2635,
	"./fish/Olive_Flounder_ACNH.png": 9710,
	"./fish/Pale_Chub_ACNH.png": 6977,
	"./fish/Pike_ACNH.png": 8450,
	"./fish/Piranha_ACNH.png": 6001,
	"./fish/Pond_Smelt_ACNH.png": 8944,
	"./fish/Popeyed_Goldfish_ACNH.png": 5630,
	"./fish/Puffer_Fish_ACNH.png": 7415,
	"./fish/Rainbowfish_ACNH.png": 1700,
	"./fish/Ranchu_Goldfish_ACNH.png": 3441,
	"./fish/Ray_ACNH.png": 916,
	"./fish/Red_Snapper_ACNH.png": 1164,
	"./fish/Ribbon_Eel_ACNH.png": 9045,
	"./fish/Saddled_Bichir_ACNH.png": 4801,
	"./fish/Salmon_ACNH.png": 6762,
	"./fish/Saw_Shark_ACNH.png": 772,
	"./fish/Sea_Bass_ACNH.png": 9597,
	"./fish/Sea_Butterfly_ACNH.png": 7011,
	"./fish/Seahorse_ACNH.png": 3104,
	"./fish/Snapping_Turtle_ACNH.png": 6053,
	"./fish/Soft_Shelled_Turtle_ACNH.png": 730,
	"./fish/Squid_ACNH.png": 1055,
	"./fish/Stringfish_ACNH.png": 7066,
	"./fish/Sturgeon_ACNH.png": 4289,
	"./fish/Suckerfish_ACNH.png": 309,
	"./fish/Surgeonfish_ACNH.png": 6672,
	"./fish/Sweetfish_ACNH.png": 8735,
	"./fish/Tadpole_ACNH.png": 3881,
	"./fish/Tilapia_ACNH.png": 6792,
	"./fish/Tuna_ACNH.png": 6160,
	"./fish/Whale_Shark_ACNH.png": 5542,
	"./fish/Yellow_Perch_ACNH.png": 5551,
	"./fish/Zebra_Turkeyfish_ACNH.png": 4910,
	"./insects/NH-Icon-agriasbutterfly.png": 92,
	"./insects/NH-Icon-ant.png": 9796,
	"./insects/NH-Icon-atlasmoth.png": 9909,
	"./insects/NH-Icon-bagworm.png": 7194,
	"./insects/NH-Icon-bandeddragonfly.png": 422,
	"./insects/NH-Icon-bellcricket.png": 129,
	"./insects/NH-Icon-blueweevilbeetle.png": 4147,
	"./insects/NH-Icon-browncicada.png": 4262,
	"./insects/NH-Icon-centipede.png": 7355,
	"./insects/NH-Icon-cicadashell.png": 9185,
	"./insects/NH-Icon-citruslonghornedbeetle.png": 1755,
	"./insects/NH-Icon-commonbluebottle.png": 2581,
	"./insects/NH-Icon-commonbutterfly.png": 9819,
	"./insects/NH-Icon-cricket.png": 3918,
	"./insects/NH-Icon-cyclommatusstag.png": 480,
	"./insects/NH-Icon-damselfly.png": 3142,
	"./insects/NH-Icon-darnerdragonfly.png": 7774,
	"./insects/NH-Icon-divingbeetle.png": 3717,
	"./insects/NH-Icon-dronebeetle.png": 1422,
	"./insects/NH-Icon-dungbeetle.png": 2216,
	"./insects/NH-Icon-earthboringdungbeetle.png": 6710,
	"./insects/NH-Icon-emperorbutterfly.png": 6711,
	"./insects/NH-Icon-eveningcicada.png": 6547,
	"./insects/NH-Icon-firefly.png": 5657,
	"./insects/NH-Icon-flea.png": 5200,
	"./insects/NH-Icon-fly.png": 783,
	"./insects/NH-Icon-giantcicada.png": 9801,
	"./insects/NH-Icon-giantstag.png": 8055,
	"./insects/NH-Icon-giantwaterbug.png": 8747,
	"./insects/NH-Icon-giraffestag.png": 7497,
	"./insects/NH-Icon-goldenstag.png": 8194,
	"./insects/NH-Icon-goliathbeetle.png": 5355,
	"./insects/NH-Icon-grasshopper.png": 9729,
	"./insects/NH-Icon-greatpurpleemperor.png": 9451,
	"./insects/NH-Icon-hermitcrab.png": 6940,
	"./insects/NH-Icon-honeybee.png": 1023,
	"./insects/NH-Icon-hornedatlas.png": 8825,
	"./insects/NH-Icon-horneddynastid.png": 7055,
	"./insects/NH-Icon-hornedelephant.png": 6040,
	"./insects/NH-Icon-hornedhercules.png": 4765,
	"./insects/NH-Icon-jewelbeetle.png": 4669,
	"./insects/NH-Icon-ladybug.png": 8200,
	"./insects/NH-Icon-longlocust.png": 3792,
	"./insects/NH-Icon-madagascansunsetmoth.png": 8433,
	"./insects/NH-Icon-manfacedstinkbug.png": 3358,
	"./insects/NH-Icon-mantis.png": 647,
	"./insects/NH-Icon-migratorylocust.png": 9347,
	"./insects/NH-Icon-miyamastag.png": 9946,
	"./insects/NH-Icon-molecricket.png": 2879,
	"./insects/NH-Icon-monarchbutterfly.png": 718,
	"./insects/NH-Icon-mosquito.png": 3197,
	"./insects/NH-Icon-moth.png": 1101,
	"./insects/NH-Icon-orchidmantis.png": 5217,
	"./insects/NH-Icon-paperkitebutterfly.png": 520,
	"./insects/NH-Icon-peacockbutterfly.png": 3714,
	"./insects/NH-Icon-pillbug.png": 1893,
	"./insects/NH-Icon-pondskater.png": 3831,
	"./insects/NH-Icon-queenalexandrasbirdwing.png": 7499,
	"./insects/NH-Icon-rainbowstag.png": 6688,
	"./insects/NH-Icon-rajahbrookesbirdwing.png": 8174,
	"./insects/NH-Icon-reddragonfly.png": 7686,
	"./insects/NH-Icon-ricegrasshopper.png": 4212,
	"./insects/NH-Icon-robustcicada.png": 73,
	"./insects/NH-Icon-rosaliabatesibeetle.png": 7902,
	"./insects/NH-Icon-sawstag.png": 6445,
	"./insects/NH-Icon-scarabbeetle.png": 4709,
	"./insects/NH-Icon-scorpion.png": 2777,
	"./insects/NH-Icon-snail.png": 6462,
	"./insects/NH-Icon-spider.png": 1518,
	"./insects/NH-Icon-stinkbug.png": 7821,
	"./insects/NH-Icon-tarantula.png": 7910,
	"./insects/NH-Icon-tigerbeetle.png": 5872,
	"./insects/NH-Icon-tigerbutterfly.png": 1217,
	"./insects/NH-Icon-violinbeetle.png": 37,
	"./insects/NH-Icon-walkercicada.png": 3823,
	"./insects/NH-Icon-walkingleaf.png": 2426,
	"./insects/NH-Icon-walkingstick.png": 3165,
	"./insects/NH-Icon-wasp.png": 4330,
	"./insects/NH-Icon-wharfroach.png": 6,
	"./insects/NH-Icon-yellowbutterfly.png": 3186,
	"./sea/Abalone.png": 2916,
	"./sea/Acorn_barnicle.png": 8855,
	"./sea/Chambered_nautilus.png": 2888,
	"./sea/Dungeoness_crab.png": 2664,
	"./sea/Firefly_squid.png": 8607,
	"./sea/Flatworm.png": 645,
	"./sea/Gazami_crab.png": 1754,
	"./sea/Giant_isopod.png": 4137,
	"./sea/Gigas_giant_clam.png": 8961,
	"./sea/Horseshoe_crab.png": 3273,
	"./sea/Lobster.png": 8222,
	"./sea/Mantis_shrimp.png": 9009,
	"./sea/Moon_jellyfish.png": 2119,
	"./sea/Mussel.png": 7030,
	"./sea/NH-Icon-seaweed.png": 804,
	"./sea/Octopus.png": 9609,
	"./sea/Oyster.png": 5772,
	"./sea/Pearl_oyster.png": 7300,
	"./sea/Red_king_crab.png": 6150,
	"./sea/Scallop.png": 8316,
	"./sea/Sea_anemone.png": 3552,
	"./sea/Sea_cucumber.png": 3793,
	"./sea/Sea_grapes.png": 9041,
	"./sea/Sea_pig.png": 4069,
	"./sea/Sea_pineapple.png": 9772,
	"./sea/Sea_slug.png": 995,
	"./sea/Sea_star.png": 3347,
	"./sea/Sea_urchin.png": 4026,
	"./sea/Slate_pencil_urchin.png": 9680,
	"./sea/Snow_crab.png": 8279,
	"./sea/Spider_crab.png": 6533,
	"./sea/Spiny_lobster.png": 9503,
	"./sea/Spotted_garden_eel.png": 1233,
	"./sea/Sweet_shrimp.png": 7946,
	"./sea/Tiger_prawn.png": 525,
	"./sea/Turban_shell.png": 5244,
	"./sea/Umbrella_octopus.png": 7304,
	"./sea/Vampire_squid.png": 4409,
	"./sea/Venus_flower_basket.png": 9762,
	"./sea/Whelk.png": 7080
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1327;